import { render } from "./Salons.vue?vue&type=template&id=99f685d4"
import script from "./Salons.vue?vue&type=script&lang=js"
export * from "./Salons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__